// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1QfKS","gfeWrapper":"CalendarEvent_gfeWrapper__3cPeZ"};